<template>
    <img alt="Logo" src="/logo.png" />
</template>
